import { forwardRef } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import type { ChatMessage } from '@/pages/Chat/ChatRoomPage'

interface IChatMessageBubbleProps {
  msg: ChatMessage
  buttonState?: 'retry' | 'continue' | undefined
  handleRetryAiResponse?: () => void
  isStreaming: boolean
}
const ChatMessageBubble = forwardRef<HTMLDivElement, IChatMessageBubbleProps>(
  ({ msg, buttonState, handleRetryAiResponse, isStreaming }, ref) => {
    return (
      <div ref={ref} key={msg.id} className={`flex flex-col ${msg.sender === 'user' ? 'items-end' : 'items-start'}`}>
        <div
          className={`max-w-[75%] px-4 py-2 rounded-2xl shadow-sm ${
            msg.sender === 'user'
              ? 'bg-white text-amber-900 rounded-br-none border border-amber-200'
              : 'bg-amber-100 text-amber-900 border border-amber-300 rounded-bl-none'
          }`}
        >
          <div className='text-sm leading-relaxed whitespace-pre-wrap'>
            {isStreaming ? (
              <span className='inline-flex items-center gap-1 animate-pulse text-[8px]'>
                <span className='animate-bounce'>●</span>
                <span className='animate-bounce' style={{ animationDelay: '100ms' }}>
                  ●
                </span>
                <span className='animate-bounce' style={{ animationDelay: '200ms' }}>
                  ●
                </span>
              </span>
            ) : buttonState === 'retry' ? (
              '대답하기까지 조금 더 생각해볼 시간이 필요해요. '
            ) : (
              <Markdown
                remarkPlugins={[remarkGfm]}
                components={{
                  code: ({ children }) => <code className=' whitespace-pre-wrap'>{children}</code>,
                  pre: ({ children }) => <pre className=' whitespace-pre-wrap'>{children}</pre>
                }}
              >
                {msg.sender === 'ai'
                  ? msg.text.replace(/\\n/g, '\n').trimStart().trimEnd().replace(/^"|"$/g, '')
                  : msg.text}
              </Markdown>
            )}
          </div>
        </div>
        {msg.sender === 'ai' && buttonState && (
          <button
            onClick={buttonState === 'retry' ? handleRetryAiResponse : undefined}
            className='text-xs px-3 py-1 rounded-2xl bg-white text-accent font-bold border border-accent shadow-xl mt-2'
          >
            {buttonState === 'retry' ? 'retry' : 'continue'}
          </button>
        )}
      </div>
    )
  }
)

export default ChatMessageBubble
